import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const FormDropDownInputElementFields = {
  group: ELEMENT_GROUPS.FORMS,
  label: 'Form Dropdown Input',
  icon: 'DocumentTextIcon',
  description: 'Adds a dropdown input form control',
  properties: [
    'layout',
    'font',
    'fontFamily',
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description:
        'Choose a data source that this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the value of this element',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Label',
      name: 'label',
      editor: 'textbox',
      description: 'The field label',
      default: 'My DropDown',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Default Value',
      name: 'defaultValue',
      editor: 'textbox',
      description: 'Default value',
      default: ' ',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Source Type',
      name: 'source',
      editor: 'dropdown',
      description: 'The data source for the list',
      default: 'static',
      options: [
        {
          label: 'Static List of Items',
          value: 'static'
        },
        {
          label: 'List of Sub-Categories',
          value: 'subcategories'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Category',
      name: 'category',
      editor: 'dropdown',
      description: 'The category to filter the list by',
      default: '',
      options: [],
      valueKey: 'name',
      function: {
        name: 'getCategories',
        params: []
      },
      displayWhen: [
        {
          field: 'source',
          operator: '=',
          value: 'subcategories'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Labels',
      name: 'labels',
      editor: 'textbox',
      description: 'The labels of items that will appear in the list',
      default: ' ',
      displayWhen: [
        {
          field: 'source',
          operator: '=',
          value: 'static'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Values',
      name: 'values',
      editor: 'textbox',
      description: 'The values of items that will appear in the list',
      default: ' ',
      displayWhen: [
        {
          field: 'source',
          operator: '=',
          value: 'static'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    'color',
    'alignment',
    'margin',
    {
      label: 'Padding',
      name: 'padding',
      editor: 'boundary',
      description: 'The padding within the input',
      default: '5 5 5 5',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    'width',
    {
      label: 'Drop Down List Height',
      name: 'listHeight',
      editor: 'number',
      description: 'Default value',
      default: 200,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    }
  ]
};

export default FormDropDownInputElementFields;
